import dataUtilities from './DataUtilities';
import { IJsonUtilities } from './IJsonUtilities';

class JsonUtilities implements IJsonUtilities {
    getBooleanValue(json: any, propName: string, defaultValue?: boolean): boolean {
        if (json.hasOwnProperty(propName)) {
            if (dataUtilities.isBoolean(json[propName], true)) {
                if (dataUtilities.isBoolean(json[propName])) {
                    return json[propName] as boolean;
                }

                if (dataUtilities.isString(json[propName])) {
                    if (json[propName] === "true" || json[propName] === "True" || json[propName] === "1") {
                        return true;
                    }
                }

                if (dataUtilities.isNumber(json[propName])) {
                    if (json[propName] === 1) {
                        return true;
                    }
                }
            }
        }

        if (defaultValue) {
            return defaultValue;
        }

        return false;
    }

    getStringValue(json: any, propName: string, defaultValue: string): string;
    getStringValue(json: any, propName: string, defaultValue?: string): string | null {
        if (json.hasOwnProperty(propName) && dataUtilities.isString(json[propName])) {
            return json[propName] as string;
        }

        if (defaultValue || defaultValue === '') {
            return defaultValue;
        }

        return null;
    }

    getNumberValue(json: any, propName: string, defaultValue?: number): number {
        if (json.hasOwnProperty(propName) &&
            dataUtilities.isNumber(json[propName])) {
            return json[propName] as number;
        }

        if (defaultValue) {
            return defaultValue;
        }

        return 0;
    }

    getDateValue(json: any, propName: string, defaultValue?: Date): Date {
        if (json.hasOwnProperty(propName)) {
            if (dataUtilities.isDate(json[propName], true)) {
                if (dataUtilities.isDate(json[propName])) {
                    return json[propName] as Date;
                }

                if (dataUtilities.isString(json[propName])) {
                    try {
                        return new Date(json[propName] as string);
                    }
                    catch (err) {
                        console.error(json[propName] + ' cannot be converted into a date.', err)
                    }
                }

                if (dataUtilities.isNumber(json[propName])) {
                    try {
                        return new Date(json[propName] as number);
                    }
                    catch (err) {
                        console.error(json[propName] + ' cannot be converted into a date.', err)
                    }
                }
            }
        }

        if (defaultValue) {
            return defaultValue;
        }

        return new Date(0);
    }

    getEnumValue<T extends string | number>(json: any, propName: string, enumObject: any, defaultValue: T): T;
    getEnumValue<T extends string | number>(json: any, propName: string, enumObject: any, defaultValue?: T): T | null {
        if (json.hasOwnProperty(propName)) {
            if (dataUtilities.isNumber(json[propName]) && Object.values(enumObject).includes(json[propName])) {
                return json[propName] as T;
            }

            if (dataUtilities.isString(json[propName])) {
                if (json[propName] in enumObject) {
                    return enumObject[json[propName]] as T;
                } else if (Object.values(enumObject).includes(json[propName])) {
                    return json[propName] as T;
                }
            }
        }

        if (defaultValue) {
            return defaultValue;
        }

        return null;
    }

    getArrayValue<T>(json: any, converter: (json: any) => T | null, propName: string, defaultValue: T[]): T[];
    getArrayValue<T>(json: any, converter: (json: any) => T | null, propName: string, defaultValue?: T[]): T[] | null {
        if (json.hasOwnProperty(propName) && dataUtilities.isArray(json[propName])) {
            let arr = json[propName] as any[];
            let res: T[] = [];
            for (let i = 0; i < arr.length; i++) {
                let itm = converter(arr[i]);
                if (itm !== null) {
                    res.push(itm);
                }
            }
            return res;
        }

        if (defaultValue) {
            return defaultValue;
        }

        return null;
    }

    getObjectValue<T>(json: any, converter: (json: any) => T, propName: string, defaultValue: T): T;
    getObjectValue<T>(json: any, converter: (json: any) => T, propName: string, defaultValue?: T): T | null {
        if (json.hasOwnProperty(propName) && dataUtilities.isObject(json[propName])) {
            let itm = json[propName] as any;
            let res = converter(itm);
            if (res != null) {
                return res;
            }
        }

        if (defaultValue) {
            return defaultValue;
        }

        return null;
    }
}


var utilities = new JsonUtilities();
export default utilities as IJsonUtilities;